import api from '../../plugins/api';

// halykMarket — выгружать ли модель на площадку. Площадка просит присылать не
// всё, а в приложении модель при этом нужна: признак у машины (forApp) общий
// для каталога приложения и витрины Халыка, поэтому выключатель отдельный.
const editContainer = ({ containerId, photo, priceList, customPrice, halykMarket }) => {
  const formData = new FormData();
  formData.append('containerId', containerId);
  formData.append('photo', photo);
  formData.append('priceList', priceList);
  formData.append('customPrice', customPrice);
  if (halykMarket !== undefined) formData.append('halykMarket', halykMarket);

  return api.post('/api/crm/cars/editContainer', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default editContainer;
